// eslint-disable-next-line no-restricted-imports
import { TertiaryButton, TertiaryButtonProps } from '@workday/canvas-kit-react/button';
import { StyledType, createComponent } from '@workday/canvas-kit-react/common';
import { tertiaryButtonColors } from '@workday/wcp-cargo-react';
import { Ref } from 'react';

export const ThemedTertiaryButton = createComponent('button')({
  Component: ({ grow, ...props }: TertiaryButtonProps & StyledType, ref: Ref<HTMLButtonElement>, Element) => (
    <TertiaryButton
      ref={ref}
      as={Element}
      colors={tertiaryButtonColors(props)}
      maxWidth={grow ? '100%' : undefined}
      width={grow ? '100%' : undefined}
      {...props}
    />
  ),
});

ThemedTertiaryButton.displayName = 'ThemedTertiaryButton';
